import React from 'react';
import { ArrowLeft, ChevronRight } from 'lucide-react';

const SPECIALTIES = [
  { name: 'Psicología', emoji: '💭', odooId: 16, durationId: 109, color: '#F0EEFB', accent: '#786ED9', desc: 'Salud mental y bienestar emocional' },
  { name: 'Ginecología', emoji: '🌸', odooId: 15, durationId: 108, color: '#FFF1F2', accent: '#E11D48', desc: 'Salud sexual y reproductiva' },
  { name: 'Nutrición', emoji: '🥗', odooId: 17, durationId: 111, color: '#F0FDF4', accent: '#16A34A', desc: 'Alimentación y hábitos saludables' },
  { name: 'Salud General', emoji: '🩺', odooId: 18, durationId: 113, color: '#EFF6FF', accent: '#2563EB', desc: 'Consultas de salud general' },
  { name: 'Entrenamiento', emoji: '💪', odooId: 21, durationId: 120, color: '#FFF7ED', accent: '#EA580C', desc: 'Rutinas y acondicionamiento físico' },
];

export default function SpecialtySelector({ onBack, onSelect }) {
  return (
    <div className="page-container" style={{ paddingBottom: 40, maxWidth: 600 }}>
      <button className="back-button animate-fadeIn" onClick={onBack}>
        <ArrowLeft size={18} />
        Volver
      </button>

      <div className="animate-fadeInUp" style={{ marginTop: 12, marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text-primary)', letterSpacing: '-0.5px' }}>
          Selecciona una especialidad
        </h1>
        <p style={{ fontSize: 14, color: 'var(--text-secondary)', marginTop: 4 }}>
          Elige el área en la que necesitas atención para unirte a la fila virtual.
        </p>
      </div>

      <div className="ss-grid animate-fadeInUp-1">
        {SPECIALTIES.map((s, i) => (
          <button
            key={s.odooId}
            className={`ss-card press-scale-card animate-fadeInUp${i > 0 ? `-${i}` : ''}`}
            onClick={() => onSelect({ id: s.odooId, name: s.name, emoji: s.emoji, color: s.color, accent: s.accent, durationId: s.durationId })}
          >
            <div 
              className="ss-emoji" 
              style={{ background: s.color }}
            >
              {s.emoji}
            </div>
            <div className="ss-info" style={{ flex: 1 }}>
              <h4>{s.name}</h4>
              <p>{s.desc}</p>
            </div>
            <ChevronRight size={20} color="var(--text-secondary)" style={{ flexShrink: 0 }} />
          </button>
        ))}
      </div>
    </div>
  );
}
